import { useRef, useEffect } from "react";

const useDidUpdateEffect = (fn, inputs) => {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) {
      fn();
    } else {
      didMount.current = true;
    }
  }, inputs);
};

export default useDidUpdateEffect;



// WEBPACK FOOTER //
// ./src/share/hooks/useDidUpdateEffect.ts